import React from 'react';
import { StakeholderType } from '@sonar-software/sonar-core';
import { Tag } from 'antd';
export const StakeholderTypeDisplay = ({ type }) => {
    const color = type === StakeholderType.Individual ? 'geekblue' : 'orange';
    return React.createElement(Tag, { color: color }, type);
};
